module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/76aab724a3dee349e125c5293ff55c0f.png";